import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private http: HttpClient) { }

  sendEmail(name: string, email: string, telephone: string, message: string, recaptchaToken: string) {
    const uri = 'https://loczpccqpe.execute-api.us-west-1.amazonaws.com/default/martinTestingSendEmailForm';
    const obj = {
      name,
      email,
      telephone,
      message,
      recaptchaToken,
    };

    return this.http.post(uri, obj, { responseType: 'text' });
  }
}